import type { AppFeatures } from '@/modules/config';
import type { TopicTypeId } from '@/modules/topic/types';

/** Whether the news topic type is enabled, per the feature flag. */
export function newsTopicTypeEnabled(features: AppFeatures): boolean {
  return features.newsTopicTypeEnabled === true;
}

/**
 * The topic type ids this flag contributes to the topic-type registry: the
 * `news` type when the flag is on, nothing when off. Aggregated by
 * `@/conditional_feature`'s `conditionalEnabledTopicTypeIds`.
 */
export function newsEnabledTopicTypeIds(features: AppFeatures): TopicTypeId[] {
  return newsTopicTypeEnabled(features) ? ['news'] : [];
}
